import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantBankService } from '../../services/wealthlane-finance-integration-services';

const useGetBankAccountType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const bankAccountType = useQuery(
    ['getBankAccountType'],
    async () => {
      return await handleRequest(
        ParticipantBankService.getApiFinanceIntegrationApiAppParticipantBankAccountType()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: String(item.id) ?? '',
          };
        });
      },
    }
  );

  return bankAccountType;
};

export default useGetBankAccountType;
